import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import { AUTH_ENABLED, oidcConfig } from "./auth/authConfig";
import { AuthGate } from "./auth/AuthGate";

import ExcalidrawApp from "./App";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();

// When auth is enabled, gate the app behind a Cognito (Entra-federated)
// sign-in. When disabled (e.g. local dev), render the app directly so the
// OIDC provider isn't required.
const app = AUTH_ENABLED ? (
  <AuthProvider {...oidcConfig}>
    <AuthGate>
      <ExcalidrawApp />
    </AuthGate>
  </AuthProvider>
) : (
  <ExcalidrawApp />
);

root.render(<StrictMode>{app}</StrictMode>);
